import { useEffect } from 'react'
import { subscribeToDemoData } from './api'

/**
 * Re-fetch when the demo store changes.
 *
 * In demo mode a write on one side (Michel assigns somebody, approves a
 * qualification, Gina ticks a checklist) has to show up on every other screen
 * without a reload, because several of them are on screen during a
 * walkthrough. On a real backend this subscribes to nothing and costs nothing:
 * Postgres is the one telling you what changed. Pass the stable reload() from
 * useAsync, or any callback wrapped in useCallback.
 */
export function useLiveReload(reload: () => void): void {
  useEffect(() => subscribeToDemoData(reload), [reload])
}
